const moment = require("moment");

export function convertTime(time1) {
  const data = moment.utc(time1).local().format("YYYY-MM-DD h:mm:ss A");

  return data;
}
export function convertTime2(time1) {
  if (time1) {
    const data = moment.utc(time1).local().format("YYYY-MM-DD");
    return data;
  } else {
    return "";
  }
}

export function getCurrentUTCTimeWithMicroseconds() {
  const m = moment.utc();
  const base = m.format("YYYY-MM-DD[T]HH:mm:ss.SSS");
  // Generate 3 random digits for microseconds
  const micro = Math.floor(Math.random() * 1000)
    .toString()
    .padStart(3, "0");
  return `${base}${micro}`;
}

export function toUTCWithMicroseconds(dateInput) {
  const m = moment.utc(dateInput, "YYYY-MM-DD");
  const base = m.format("YYYY-MM-DD[T]HH:mm:ss.SSS");
  // Add 3 random digits for microseconds
  const micro = Math.floor(Math.random() * 1000)
    .toString()
    .padStart(3, "0");
  return `${base}${micro}`;
}
